import { render } from "./positionImg.vue?vue&type=template&id=767b28ee&scoped=true"
import script from "./positionImg.vue?vue&type=script&lang=js"
export * from "./positionImg.vue?vue&type=script&lang=js"

import "./positionImg.vue?vue&type=style&index=0&id=767b28ee&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767b28ee"]])

export default __exports__